<template>
  <div>
    <div class="pf-title">Performance Insights</div>
    <!-- 筛选框 -->
    <div class="pfSearch">
      <Form
        ref="performanceForm"
        :model="performanceForm"
        :rules="ruleValidate"
      >
        <Row>
          <Col span="24">
            <Row
              style="
                width: 100%;
                background-color: #fff;
                height: 53px;
                padding-top: 7px;
              "
            >
              <Col span="24">
                <Row :gutter="10">
                  <!-- 公司 -->
                  <Col span="4">
                    <FormItem label="" prop="companyId">
                      <Select
                        v-model="performanceForm.companyId"
                        filterable
                        :transfer="true"
                        @on-change="changeMonitorIndex()"
                        :placeholder="$t('KPI.pleaseSelectCompany')"
                      >
                        <Option
                          v-for="item in companyIdList"
                          :value="item.id"
                          :key="item.id"
                          >{{ item.companyName }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 账号 -->
                  <Col span="4">
                    <FormItem label="" prop="accountId">
                      <Select
                        v-model="performanceForm.accountId"
                        filterable
                        :transfer="true"
                        placeholder="请选择账号"
                        @on-change="changeAccountId(performanceForm.accountId)"
                      >
                        <Option
                          v-for="item in accountIdList"
                          :value="item.id"
                          :key="item.name"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 区域 -->
                  <Col span="4">
                    <FormItem label="" prop="region">
                      <Select
                        v-model="performanceForm.region"
                        filterable
                        :transfer="true"
                        placeholder="请选择区域"
                      >
                        <Option
                          v-for="item in regionList"
                          :value="item.key"
                          :key="item.name"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 数据库 -->
                  <Col span="4">
                    <FormItem label="" prop="databaseId">
                      <Select
                        v-model="performanceForm.databaseId"
                        filterable
                        :transfer="true"
                        placeholder="请选择数据库"
                      >
                        <Option
                          v-for="item in databaseIdList"
                          :value="item.id"
                          :key="item.name"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 时间范围 -->
                  <Col span="4">
                    <FormItem label="" prop="viewPast">
                      <Select
                        v-model="performanceForm.viewPast"
                        filterable
                        :transfer="true"
                        placeholder="请选择时间范围"
                      >
                        <Option
                          v-for="item in viewPastList"
                          :value="item.id"
                          :key="item.name"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="4">
                    <Button
                      type="primary"
                      @click="searchAll('performanceForm')"
                      >{{ $t("cudrecommendation.search") }}</Button
                    >
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
    <!-- 柱状图 -->
    <Row :gutter="10" style="margin-bottom: 10px">
      <Col span="24">
        <Card :padding="8">
          <Row>
            <Col>
              <Row>
                <Col span="18" class="title">database load</Col>
              </Row>
              <Row>
                <Col span="4">
                  <Select
                    v-model="performanceForm.showvCPUs"
                    filterable
                    :transfer="true"
                    @on-change="changeshowvCPUs()"
                  >
                    <Option
                      v-for="item in showvCPUsList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </Col>

                <!-- 阶段 -->
                <Col span="5" style="float: right">
                  <Select
                    v-model="performanceForm.sliceBy"
                    filterable
                    :transfer="true"
                    @on-change="changeSliceBy()"
                  >
                    <Option
                      v-for="item in sliceByList"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col>
              <div id="mainTest" style="width: 100%; height: 300px"></div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <!-- tab -->
    <Row style="margin-bottom: 10px">
      <Col span="24">
        <Tabs size="small" @on-click="LoadTab" :animated="false">
          <TabPane label="Top waits" :name="0" key="0">
            <div style="width: 100%; height: 500px">
              <Row>
                <Col span="12">
                  <div
                    style="width: 100%; height: 500px"
                    v-if="TabIndex == 0"
                    id="topWaits0"
                  ></div>
                </Col>
                <Col span="12" class="table">
                  <List
                    class="TableList"
                    size="small"
                    style="height: 500px; box-sizing: border-box"
                  >
                    <!--  class="shin" -->
                    <ListItem
                      style="height: 6.8%; margin-bottom: 0.53%"
                      v-for="(item, index) in TopNameList"
                      :key="index"
                    >
                      <Poptip trigger="hover" :content="item.dimensionName">
                        <Row>{{
                          SubContentStr(item.dimensionName)
                        }}</Row></Poptip
                      ></ListItem
                    >
                  </List>
                </Col>
              </Row>
            </div>
          </TabPane>
          <TabPane label="Top SQL" :name="1" key="1">
            <div style="width: 100%; height: 500px">
              <List size="small" style="height: 500px; box-sizing: border-box">
                <Row>
                  <Col span="12">
                    <div
                      style="width: 100%; height: 500px"
                      v-if="TabIndex == 1"
                      id="topWaits1"
                    ></div>
                  </Col>
                  <Col span="12" class="table">
                    <List size="small">
                      <ListItem
                        style="height: 6.8%; margin-bottom: 0.53%"
                        v-for="(item, index) in TopSqlList"
                        :key="index"
                      >
                        <Poptip trigger="hover" :content="item.dimensionName">
                          <Row>{{
                            SubContentStr(item.dimensionName)
                          }}</Row></Poptip
                        >
                        >
                      </ListItem>
                    </List>
                  </Col>
                </Row>
              </List>
            </div>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil";
export default {
  name: "PerformanceInsights",
  components: {},
  data() {
    return {
      TabIndex: 0,
      ecoption: {
        autoresize: false,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: [
          {
            type: "category",
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
          },
        ],
        series: [],
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      },
      currentTab: "",
      accountId: [],
      xAxisDate: [],
      companyArray: [],
      waitsArray: [],
      accountIdList: [],
      companyIdList: [],
      databaseIdList: [],
      regon: "",
      regionList: [],
      viewPastList: [
        {
          id: "5",
          name: "5m",
        },
        {
          id: "60",
          name: "1h",
        },
        {
          id: "300",
          name: "5h",
        },
        {
          id: "1440",
          name: "24h",
        },
        {
          id: "10080",
          name: "1w",
        },
        {
          id: "10080",
          name: "all",
        },
      ],
      sliceByList: [
        {
          id: "1",
          name: "sql",
        },
        {
          id: "2",
          name: "wait",
        },
      ],
      showvCPUsList: [
        {
          id: "1",
          name: "是",
        },
        {
          id: "0",
          name: "否",
        },
      ],
      databaseId: "",
      sliceBy: "",
      performanceForm: {
        companyId: "",
        accountId: "",
        databaseId: "",
        viewPast: "",
        sliceBy: "1",
        showvCPUs: "1",
        //  region: "",
      },
      TopNameList: [],
      TopSqlList: [],
      ruleValidate: {
        companyId: [
          {
            required: true,
            message: "请选择公司",
          },
        ],
        accountId: [
          {
            required: true,
            message: "请选择账户名称",
          },
        ],
        region: [
          {
            required: true,
            message: "请选择区域",
          },
        ],
        databaseId: [
          {
            required: true,
            message: "请选择数据库名称",
          },
        ],
        viewPast: [
          {
            required: true,
            message: "请选择时间范围",
          },
        ],
      },
      chartPfUsage: "", //柱状图
      chartTopWaits: "",
      chartTopSql: "", //堆叠条形图
    };
  },
  mounted() {
    //this.init();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function () {
      self.companyArray.resize();
      self.chartTopWaits.resize();
      self.waitsArray.resize();
    });
  },
  created() {
    this.$nextTick(function () {
      // 公司
      this.listRegisterInformation();
      //堆叠条形图
      // this.checkTopWaits();
    });
  },
  methods: {
    SubContentStr: function (v) {
      if (v.length <= 50) {
        return v;
      }
      return String(v).substring(0, 20) + "...";
    },
    //切换公司
    changeMonitorIndex: function () {
      this.getAWSAccountByCompanyId();
    },
    //切换账户
    changeAccountId: function () {
      this.queryAccountRegions();
      this.queryDatabaseByAccountId();
    },
    //切换阶段
    changeSliceBy: function () {
      this.performancePage();
    },
    //是否显示最大数值
    changeshowvCPUs: function () {
      this.performancePage();
    },
    /*********************查询************************/
    searchAll: function () {
      this.performancePage();
      this.toplist();
    },

    // 公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        this.companyIdList = res.data.companies;

        if (this.companyIdList) {
          this.performanceForm.companyId = this.companyIdList[0].id;
        }
        this.accountId = [];
        this.getAWSAccountByCompanyId();
      });
    },
    //账户
    getAWSAccountByCompanyId: function () {
      this.$api.account
        .getAWSAccountByCompanyId("companyId", this.performanceForm.companyId)
        .then((res) => {
          this.accountIdList = res.data;
          //默认账户全选
          if (this.accountIdList) {
            for (var i = 0; i < this.accountidList.length; i++) {
              this.accountId.push(this.accountIdList[i].id);
            }
          }
          eventBus.$emit("companyId", this.performanceForm.companyId);
          eventBus.$emit("accountId", this.performanceForm.accountId);
          this.queryAccountRegions();
          this.queryDatabaseByAccountId();
        });
    },
    //区域
    queryAccountRegions: function () {
      this.$api.account
        .queryAccountRegions("accountId", this.performanceForm.accountId)
        .then((res) => {
          this.regionList = res.data;
        });
    },
    //数据库
    queryDatabaseByAccountId: function () {
      this.$api.rds
        .queryDatabaseByAccountId("accountId", this.performanceForm.accountId)
        .then((res) => {
          this.databaseIdList = res.data;
        });
    },

    /******************page页面********************************/
    performancePage: function () {
      this.$api.performance
        .sliceby({
          accountId: this.performanceForm.accountId,
          companyId: this.performanceForm.companyId,
          region: this.performanceForm.region,
          databaseId: this.performanceForm.databaseId,
          identifier: this.performanceForm.identifier,
          showvCPUs: this.performanceForm.showvCPUs,
          sliceBy: this.performanceForm.sliceBy,
          viewPast: this.performanceForm.viewPast,
        })
        .then((res) => {
          if (res.data.metricList.length != 0) {
            res.data.metricList[0].dataPoints.map((item) => {
              this.xAxisDate.push(item.timeStamp);
            });
            for (let i = 0; i < res.data.metricList.length; i++) {
              this.companyArray.push({
                type: "bar",
                stack: "Search Engine",
                emphasis: {
                  focus: "series",
                },
                name: res.data.metricList[i].metricName,
                data: [],
              });
              for (
                let j = 0;
                j < res.data.metricList[i].dataPoints.length;
                j++
              ) {
                this.companyArray[i].data.push(
                  res.data.metricList[i].dataPoints[j].value
                );
              }
            }
            this.ecoption.xAxis[0].data = this.xAxisDate;
            this.ecoption.series = this.companyArray;
            let chartDom = document.getElementById("mainTest");
            let myChart = this.$echarts.init(chartDom);
            myChart.setOption(this.ecoption);
          }
        });
    },
    getGroup: (data, key) => {
      let groups = {};
      data.forEach((c) => {
        let value = c[key];
        groups[value] = groups[value] || [];
        groups[value].push(c);
      });
      return groups;
    },
    LoadTab: function (name) {
      this.TabIndex = name;
      if (Boolean(name)) {
        this.topSql();
      } else {
        this.toplist();
      }
    },
    /******************堆叠条形图********************************/
    toplist: function () {
      this.$api.performance
        .toplist({
          accountId: this.performanceForm.accountId,
          region: this.performanceForm.region,
          databaseId: this.performanceForm.databaseId,
          viewPast: this.performanceForm.viewPast,
          top: 2,
        })
        .then((res) => {
          this.init(res);
          if (res.data.dimensions.length != 0) {
            let num = [];
            res.data.dimensions.map((item) => {
              num.push(item.total);
            });
            this.waitsArr = num;
          }
          let chartDom = document.getElementById("mainTest");
          let waitsChart = this.$echarts.init(chartDom);
          waitsChart.setOption(this.ecoption);
        });
    },
    init: function (res) {
      this.$nextTick(function () {
        this.toplistLine(res);
      });
    },
    toplistLine: function (res) {
      this.TopNameList = res.data.dimensions;
      this.chartTopWaits = this.$echarts.init(
        document.getElementById("topWaits0")
      );
      this.chartTopWaits.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "1%",
          right: "1%",
          top: "1%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        yAxis: {
          type: "category",
          show: false,
          axisLabel: {
            formatter: function (params) {
              var maxLength = 25;
              //判断长度，超出使用...代替
              if (params && params.length > maxLength) {
                return params.substring(0, maxLength - 1) + "...";
              } else {
                return params;
              }
            },
          },
          inverse: true,
          max: 10,
        },
        series: [
          {
            type: "bar",
            barWidth: 20,
            data: this.waitsArr,
          },
        ],
      });
    },
    //topS
    topSql: function () {
      this.$api.performance
        .toplist({
          accountId: this.performanceForm.accountId,
          region: this.performanceForm.region,
          databaseId: this.performanceForm.databaseId,
          viewPast: this.performanceForm.viewPast,
          top: 1,
        })
        .then((res) => {
          this.initSql(res);
          if (res.data.dimensions.length != 0) {
            let num = [];
            res.data.dimensions.map((item) => {
              num.push(item.total);
            });
            this.waitsArr = num;
          }
          let chartDom = document.getElementById("mainTest");
          let waitsChart = this.$echarts.init(chartDom);
          waitsChart.setOption(this.ecoption);
        });
    },
    initSql: function (res) {
      this.$nextTick(function () {
        this.topSqlLine(res);
      });
    },
    topSqlLine: function (res) {
      this.TopSqlList = res.data.dimensions;
      this.chartTopWaits = this.$echarts.init(
        document.getElementById("topWaits1")
      );
      this.chartTopWaits.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        legend: {},
        grid: {
          left: "1%",
          right: "1%",
          top: "1%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        yAxis: {
          type: "category",
          show: false,
          axisLabel: {
            formatter: function (params) {
              var maxLength = 25;
              //判断长度，超出使用...代替
              if (params && params.length > maxLength) {
                return params.substring(0, maxLength - 1) + "...";
              } else {
                return params;
              }
            },
          },
          inverse: true,
          max: 10,
        },
        series: [
          {
            barWidth: 20,
            type: "bar",
            data: this.waitsArr,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.pf-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}
.title {
  font-size: 13px;
  font-weight: 600;
  padding: 10px;
  float: left;
  color: #000;
}
a {
  text-decoration: underline;
}
.shin {
  padding: 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/pf/PerformanceInsights.vue